module.exports = __webpack_public_path__ + "static/img/out12.bc5d7765.png";